import confettiBall from "@/assets/confetti-ball.png";

const ASSESSMENT_TYPES = {
  exit_ticket: {
    key: "exit_ticket",
    label: "Exit Ticket",
    fetchUrl: (lessonId) => `/exit-ticket/lesson/${lessonId}`,
    startUrl: (ticketId) => `/exit-ticket/${ticketId}/start`,
    autoSaveUrl: (ticketId) => `/exit-ticket/${ticketId}/auto-save`,
    submitUrl: (ticketId) => `/exit-ticket/${ticketId}/submit`,
    attemptsUrl: (ticketId) => `/exit-ticket/${ticketId}/attempts`,
    modal: {
      title: "Great job on finishing the lesson!",
      body: "Ready for a quick challenge to show\nwhat you\u2019ve learned?",
      startButton: "Start Exit Ticket",
      skipButton: "Maybe later, exit lesson",
      icon: confettiBall,
      iconBg: "#FFCE3B29",
      iconPadding: 20,
      accentColor: "#1C9C6D",
      accentHover: "#178A5F",
      badgeColors: { bg: "#E8F5E9", text: "#2E7D32" },
    },
    survey: {
      submitLabel: "Submit Exit Ticket",
      accentColor: "#169165",
      accentHover: "#137a55",
    },
    notification: {
      title: "Moving to Exit ticket in {{seconds}}",
      subtitle: "If you have any questions, please ask\nthe tutor.",
    },
    autoTransition: null,
  },
  pre_assessment: {
    key: "pre_assessment",
    label: "Pre-Assessment",
    fetchUrl: (lessonId) => `/exit-ticket/pre-assessment/lesson/${lessonId}`,
    startUrl: (ticketId) => `/exit-ticket/${ticketId}/start`,
    autoSaveUrl: (ticketId) => `/exit-ticket/${ticketId}/auto-save`,
    submitUrl: (ticketId) => `/exit-ticket/${ticketId}/submit`,
    attemptsUrl: (ticketId) => `/exit-ticket/${ticketId}/attempts`,
    modal: {
      title: "Before we begin...",
      body: "Let\u2019s start with a quick pre-assessment to\nsee what you already know.",
      startButton: "Start Pre-Assessment",
      skipButton: "Skip for now",
      icon: null,
      accentColor: "#1C9C6D",
      accentHover: "#178A5F",
      badgeColors: { bg: "#F5FFEE", text: "#03A76B" },
    },
    survey: {
      submitLabel: "Submit Pre-Assessment",
      accentColor: "#169165",
      accentHover: "#137a55",
    },
    notification: {
      title: "Moving to Pre-Assessment in {{seconds}}",
      subtitle: "Let\u2019s see what you already know.",
    },
    autoTransition: {
      title: "Moving to the lesson in {{seconds}}",
      durationMs: 3000,
    },
  },
  custom: {
    key: "custom",
    label: "Survey",
    fetchUrl: (lessonId) => `/exit-ticket/custom/lesson/${lessonId}`,
    startUrl: (ticketId) => `/exit-ticket/${ticketId}/start`,
    autoSaveUrl: (ticketId) => `/exit-ticket/${ticketId}/auto-save`,
    submitUrl: (ticketId) => `/exit-ticket/${ticketId}/submit`,
    attemptsUrl: (ticketId) => `/exit-ticket/${ticketId}/attempts`,
    modal: {
      title: "Before we move ahead\u2026",
      body: "Answer a few questions before\ncontinuing the lesson.",
      bodyColor: "#252525",
      startButton: "Continue",
      skipButton: "Skip for now",
      icon: null,
      showLessonBadge: false,
      width: 450,
      accentColor: "#1C9C6D",
      accentHover: "#178A5F",
      badgeColors: { bg: "#F5FFEE", text: "#03A76B" },
    },
    survey: {
      submitLabel: "Submit",
      accentColor: "#169165",
      accentHover: "#137a55",
    },
    notification: {
      title: "Quick check coming up in {{seconds}}",
      subtitle: "Your tutor has a question for you.",
    },
    autoTransition: {
      title: "Moving to the next bite in {{seconds}}",
      durationMs: 3000,
    },
  },
};

export const ASSESSMENT_KEYS = Object.keys(ASSESSMENT_TYPES);

const ASSESSMENT_KEY_SET = new Set(ASSESSMENT_KEYS);

export const isAssessmentSlideType = (slideType) =>
  slideType != null && ASSESSMENT_KEY_SET.has(slideType);

// A practice bite publishes with no slide_html of its own; its preview is the
// diagram on the linked host slide (see practiceDiagramLoader). slide_type is
// the backend's slide_object.slide_type column, the only marker of a practice.
export const isPracticeSlideType = (slideType) => slideType === "practice";

export const makeEmptySlice = () => ({
  data: null,
  id: null,
  attemptId: null,
  attemptNumber: null,
  isActive: false,
  completed: false,
  score: null,
  has: false,
  state: null,
  attemptsCount: 0,
  savedResponses: null,
  percentAnswered: null,
});

export default ASSESSMENT_TYPES;
